import logWebHeaderUpgradeToProTapped from '@alltrails/analytics/events/logWebHeaderUpgradeToProTapped';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import { wrapUrlSafe } from 'utils/language_support_util';
import useUser from 'hooks/useUser';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import WebHeaderUpgradeToProCopyText from '@alltrails/analytics/enums/WebHeaderUpgradeToProCopyText';
import * as styles from './styles/styles.module.scss';

export default function MobileHomeLink() {
  const user = useUser();
  const languageRegionCode = useLanguageRegionCode();

  if (!user) {
    return (
      <a className={styles.link} href={wrapUrlSafe('/signup?ref=homepage_signup_mobileheader', languageRegionCode)}>
        <FormattedMessage defaultMessage="Sign up" />
      </a>
    );
  }

  return (
    <a
      className={styles.link}
      href={wrapUrlSafe('/pro?ref=homepage_pro_mobileheader', languageRegionCode)}
      onClick={() => {
        logWebHeaderUpgradeToProTapped({
          copy_text: user.isPromoEligible ? WebHeaderUpgradeToProCopyText.TryProFree : WebHeaderUpgradeToProCopyText.UpgradeToPro
        });
      }}
    >
      {user.isPromoEligible ? <FormattedMessage defaultMessage="Try Pro" /> : <FormattedMessage defaultMessage="Get Pro" />}
    </a>
  );
}
